export const fadeInUp = {
    initial: {
        opacity: 0,
        y: 60
    },
    animate: {
        opacity: 1,
        y: 0
    },
    hidden: {
        opacity: 0,
        y: 60
    }
}



export const stagger = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: 0.1,
        }
    }
}